import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const RaceInfoWrapper = styled.div(() =>
  mq({
    width: ['100%', '100%', '100%', '100%', '620px'],
  }),
);

export const CurrentRaceWrapper = styled.div(() =>
  mq({
    display: 'block',
    width: ['100%', '100%', '100%', '100%', '620px'],
    marginTop: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      0,
    ],
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      `${defaultTheme.spacing.l} 0`,
      0,
    ],
    '& > p': {
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
      lineHeight: defaultTheme.font.height.base,
      marginBottom: defaultTheme.spacing.l,
    },
    '& > span': {
      padding: '40px 0',
    },
  }),
);

export const TableWrapper = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: '#fff',
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const SheetWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: defaultTheme.spacing.l,
  }),
);

export const BetSheetWrapper = styled.div(() =>
  mq({
    marginLeft: defaultTheme.spacing.s,
  }),
);

export const RaceCardWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    width: '1px', // 横スクロールするためにとりあえずwidthを指定しているだけで作用はしない,
  }),
);

export const ListWrapper = styled.ul(() =>
  mq({
    display: 'grid',
    gridGap: `${defaultTheme.spacing.xxl} 0`,
    margin: [0, 0, '40px 0', '40px 0'],
    '& > div': {
      padding: [0, 0, `0 ${defaultTheme.spacing.xxl}`, '0 94px'],
    },
  }),
);

export const EmptyWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: ['150px', '150px', '200px', '200px'],
  }),
);

export const EmptyText = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
  }),
);
